var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-container", { attrs: { "grid-list-md": "" } }, [
    _c(
      "div",
      [
        _c("div", { staticClass: "holder" }, [
          _c(
            "h2",
            { attrs: { id: "page-header" } },
            [
              _c("router-link", { attrs: { to: "/" } }, [
                _vm._v("My Arlington -")
              ]),
              _c("router-link", { attrs: { to: "/digitalresources" } }, [
                _vm._v(" Digital Resources")
              ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.alert ? _c("v-flex", { staticClass: "layer-page" }) : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "layer-page" }, [
          _c("div", { staticClass: "widget one-third filter-pane" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isMobile || _vm.mobileMenu === false,
                    expression: "isMobile || mobileMenu === false"
                  }
                ],
                staticClass: "filter-header",
                attrs: {
                  type: "button",
                  id: "mobile-menu",
                  "aria-expanded": _vm.mobileMenu ? "true" : "false",
                  "aria-controls": "filters-and-settings"
                },
                on: {
                  click: function($event) {
                    _vm.mobileMenu = !_vm.mobileMenu
                  }
                }
              },
              [
                _vm._v(
                  "\n                  Filters and Location\n                  "
                ),
                _c(
                  "svg",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.mobileMenu,
                        expression: "!mobileMenu"
                      }
                    ],
                    staticClass: "icon",
                    staticStyle: { float: "right" },
                    attrs: { "aria-hidden": "true", focusable: "false" }
                  },
                  [_c("use", { attrs: { "xlink:href": "#icon-plus" } })]
                ),
                _vm._v(" "),
                _c(
                  "svg",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.mobileMenu,
                        expression: "mobileMenu"
                      }
                    ],
                    staticClass: "icon",
                    staticStyle: { float: "right" },
                    attrs: { "aria-hidden": "true", focusable: "false" }
                  },
                  [_c("use", { attrs: { "xlink:href": "#icon-minus" } })]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isMobile || _vm.mobileMenu,
                    expression: "!isMobile || mobileMenu"
                  }
                ],
                attrs: { id: "filters-and-settings" }
              },
              [
                _c("div", { staticClass: "filter-container" }, [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isMobile,
                          expression: "!isMobile"
                        }
                      ],
                      staticClass: "filter-header",
                      attrs: {
                        type: "button",
                        "aria-expanded": _vm.filtersExpanded ? "true" : "false",
                        "aria-controls": "digital-resources-filter-list"
                      },
                      on: { click: _vm.filtersToggle }
                    },
                    [
                      _c("span", [
                        _vm._v("Filters\n                              "),
                        _c(
                          "svg",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.filtersExpanded,
                                expression: "filtersExpanded"
                              }
                            ],
                            staticClass: "icon",
                            staticStyle: { float: "right" },
                            attrs: { "aria-hidden": "true", focusable: "false" }
                          },
                          [
                            _c("use", {
                              attrs: { "xlink:href": "#icon-minus" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.filtersExpanded,
                                expression: "!filtersExpanded"
                              }
                            ],
                            staticClass: "icon",
                            staticStyle: { float: "right" },
                            attrs: { "aria-hidden": "true", focusable: "false" }
                          },
                          [_c("use", { attrs: { "xlink:href": "#icon-plus" } })]
                        ),
                        _vm._v(" "),
                        _c("span", {
                          staticStyle: { clear: "both", display: "block" }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.filtersExpanded || _vm.mobileMenu,
                          expression: "filtersExpanded || mobileMenu"
                        }
                      ],
                      staticClass: "filterList",
                      attrs: { id: "digital-resources-filter-list" }
                    },
                    [
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "filter-item filter-category" },
                        [_vm._v("Availability")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "filter-item" }, [
                        _c("label", { staticClass: "filter-checkbox-label" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.typeSelected,
                                expression: "typeSelected"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              value: "Computer",
                              checked: Array.isArray(_vm.typeSelected)
                                ? _vm._i(_vm.typeSelected, "Computer") > -1
                                : _vm.typeSelected
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.typeSelected,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = "Computer",
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.typeSelected = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.typeSelected = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.typeSelected = $$c
                                  }
                                },
                                function($event) {
                                  return _vm.filterChange($event)
                                }
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "tooltip" },
                            [
                              _c("DesktopIcon", {
                                attrs: { title: "Computer" }
                              }),
                              _vm._v(" Computer")
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "filter-item" }, [
                        _c("label", { staticClass: "filter-checkbox-label" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.typeSelected,
                                expression: "typeSelected"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              value: "WiFi",
                              checked: Array.isArray(_vm.typeSelected)
                                ? _vm._i(_vm.typeSelected, "WiFi") > -1
                                : _vm.typeSelected
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.typeSelected,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = "WiFi",
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.typeSelected = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.typeSelected = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.typeSelected = $$c
                                  }
                                },
                                function($event) {
                                  return _vm.wifiChange($event)
                                }
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "tooltip" },
                            [
                              _c("WifiIcon", { attrs: { title: "Wi-Fi" } }),
                              _vm._v(" Wi-Fi")
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.typeSelected.includes("WiFi")
                        ? _c(
                            "div",
                            { staticClass: "filter-item filter-item-nested" },
                            [
                              _c(
                                "label",
                                { staticClass: "filter-checkbox-label" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.typeSelected,
                                        expression: "typeSelected"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      value: "IndoorWiFi",
                                      checked: Array.isArray(_vm.typeSelected)
                                        ? _vm._i(
                                            _vm.typeSelected,
                                            "IndoorWiFi"
                                          ) > -1
                                        : _vm.typeSelected
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a = _vm.typeSelected,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = "IndoorWiFi",
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.typeSelected = $$a.concat([
                                                  $$v
                                                ]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.typeSelected = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.typeSelected = $$c
                                          }
                                        },
                                        function($event) {
                                          return _vm.wifiChange($event)
                                        }
                                      ]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "tooltip" },
                                    [
                                      _c("WifiIcon", {
                                        attrs: { title: "Wi-Fi" }
                                      }),
                                      _vm._v(
                                        " Indoor\n                                "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "tooltiptext" },
                                        [
                                          _vm._v(
                                            "Free public Wi-Fi available inside the facility."
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.typeSelected.includes("WiFi")
                        ? _c(
                            "div",
                            { staticClass: "filter-item filter-item-nested" },
                            [
                              _c(
                                "label",
                                { staticClass: "filter-checkbox-label" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.typeSelected,
                                        expression: "typeSelected"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      value: "DriveWiFi",
                                      checked: Array.isArray(_vm.typeSelected)
                                        ? _vm._i(
                                            _vm.typeSelected,
                                            "DriveWiFi"
                                          ) > -1
                                        : _vm.typeSelected
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a = _vm.typeSelected,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = "DriveWiFi",
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.typeSelected = $$a.concat([
                                                  $$v
                                                ]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.typeSelected = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.typeSelected = $$c
                                          }
                                        },
                                        function($event) {
                                          return _vm.wifiChange($event)
                                        }
                                      ]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "tooltip" },
                                    [
                                      _c("WifiIcon", {
                                        staticClass: "wifi-icon-outdoor",
                                        attrs: { title: "Wi-Fi" }
                                      }),
                                      _vm._v(
                                        " Outdoor\n                                "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "tooltiptext" },
                                        [
                                          _vm._v(
                                            "Free public Wi-Fi available outside the facility."
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "filter-item" }, [
                        _c("label", { staticClass: "filter-checkbox-label" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.typeSelected,
                                expression: "typeSelected"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              value: "Printing",
                              checked: Array.isArray(_vm.typeSelected)
                                ? _vm._i(_vm.typeSelected, "Printing") > -1
                                : _vm.typeSelected
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.typeSelected,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = "Printing",
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.typeSelected = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.typeSelected = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.typeSelected = $$c
                                  }
                                },
                                function($event) {
                                  return _vm.filterChange($event)
                                }
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "tooltip" },
                            [
                              _c("PrinterIcon", {
                                attrs: { title: "Printer" }
                              }),
                              _vm._v(" Printer")
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "filter-item" }, [
                        _c("label", { staticClass: "filter-checkbox-label" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.typeSelected,
                                expression: "typeSelected"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              value: "Scanning",
                              checked: Array.isArray(_vm.typeSelected)
                                ? _vm._i(_vm.typeSelected, "Scanning") > -1
                                : _vm.typeSelected
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.typeSelected,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = "Scanning",
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.typeSelected = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.typeSelected = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.typeSelected = $$c
                                  }
                                },
                                function($event) {
                                  return _vm.filterChange($event)
                                }
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "tooltip" },
                            [
                              _c("ScannerIcon", {
                                attrs: { title: "Scanner" }
                              }),
                              _vm._v(" Scanner")
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.filtersExpanded || _vm.mobileMenu,
                              expression: "filtersExpanded || mobileMenu"
                            }
                          ],
                          staticClass: "filterList"
                        },
                        [
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "filter-item filter-category" },
                            [_vm._v("Public Transit")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "filter-item" }, [
                            _c(
                              "label",
                              { staticClass: "filter-checkbox-label" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.typeSelected,
                                      expression: "typeSelected"
                                    }
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    value: "Bus",
                                    checked: Array.isArray(_vm.typeSelected)
                                      ? _vm._i(_vm.typeSelected, "Bus") > -1
                                      : _vm.typeSelected
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = _vm.typeSelected,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "Bus",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.typeSelected = $$a.concat([
                                                $$v
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.typeSelected = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.typeSelected = $$c
                                        }
                                      },
                                      function($event) {
                                        return _vm.filterChange($event)
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "tooltip" },
                                  [
                                    _c("BusIcon", { attrs: { title: "Bus" } }),
                                    _vm._v(" Bus")
                                  ],
                                  1
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "filter-item" }, [
                            _c(
                              "label",
                              { staticClass: "filter-checkbox-label" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.typeSelected,
                                      expression: "typeSelected"
                                    }
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    value: "Metro",
                                    checked: Array.isArray(_vm.typeSelected)
                                      ? _vm._i(_vm.typeSelected, "Metro") > -1
                                      : _vm.typeSelected
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = _vm.typeSelected,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "Metro",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.typeSelected = $$a.concat([
                                                $$v
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.typeSelected = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.typeSelected = $$c
                                        }
                                      },
                                      function($event) {
                                        return _vm.filterChange($event)
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "tooltip" },
                                  [
                                    _c("SubwayIcon", {
                                      attrs: { title: "Metro" }
                                    }),
                                    _vm._v(" Metro")
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("h3", [_vm._v("Zoom to Location")]),
                _vm._v(" "),
                _c("div", { staticClass: "filter-container" }, [
                  _c("label", { attrs: { for: "facility" } }, [
                    _vm._v("Facility")
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.facilitySelected,
                            expression: "facilitySelected"
                          }
                        ],
                        attrs: { id: "facility" },
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.facilitySelected = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function($event) {
                              return _vm.facilityChange($event)
                            }
                          ]
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("Select a facility")
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.facilities, function(f) {
                          return _c(
                            "option",
                            { key: f, domProps: { value: f } },
                            [_vm._v(_vm._s(f))]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "filter-container" }, [
                  _c("label", { attrs: { for: "facilitytype" } }, [
                    _vm._v("Facility type")
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.facilityTypeSelected,
                            expression: "facilityTypeSelected"
                          }
                        ],
                        attrs: { id: "facilitytype" },
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.facilityTypeSelected = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function($event) {
                              return _vm.facilityChange($event)
                            }
                          ]
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("Select a facility type")
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.facilityTypes, function(f) {
                          return _c(
                            "option",
                            { key: f, domProps: { value: f } },
                            [_vm._v(_vm._s(f))]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-container zoom-container" },
                  [
                    _c("label", { attrs: { for: "addressSearch" } }, [
                      _vm._v("Address")
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("gmap-autocomplete", {
                      ref: "autocomplete",
                      attrs: {
                        id: "addressSearch",
                        placeholder: "Enter street address"
                      },
                      on: { place_changed: _vm.placeChanged }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "filter-container" }, [
                  _c("label", { attrs: { for: "withinRadius" } }, [
                    _vm._v("Within")
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.radiusSelected,
                            expression: "radiusSelected"
                          }
                        ],
                        attrs: {
                          id: "withinRadius",
                          disabled: !_vm.selectedCoordinates
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.radiusSelected = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("Set radius")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "0.5" } }, [
                          _vm._v("0.5 Mile")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "1" } }, [
                          _vm._v("1 Mile")
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.civicAssociationFailure,
                          expression: "civicAssociationFailure"
                        }
                      ]
                    },
                    [_vm._v("Unable to load Civic Assocations.")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "filter-container" }, [
                  _c(
                    "button",
                    {
                      staticClass: "link filter-header",
                      on: { click: _vm.clearAll }
                    },
                    [_vm._v("Clear All")]
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "widget full-map-pane toggle-window" },
            [
              _c("div", { staticStyle: { position: "relative", top: "0" } }, [
                _c(
                  "div",
                  {
                    staticClass: "toggle-bar",
                    attrs: { role: "group", "aria-label": "Map or list" }
                  },
                  [
                    _c(
                      "button",
                      {
                        class:
                          _vm.showMap === true
                            ? "toggle-link"
                            : "toggle-link active",
                        attrs: {
                          type: "button",
                          "aria-pressed": _vm.showMap === true
                        },
                        on: {
                          click: function($event) {
                            _vm.showMap = true
                          }
                        }
                      },
                      [_vm._v("Map")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        class:
                          _vm.showMap === false
                            ? "toggle-link"
                            : "toggle-link active",
                        attrs: {
                          type: "button",
                          "aria-pressed": _vm.showMap === false,
                          id: "list-link"
                        },
                        on: {
                          click: function($event) {
                            _vm.showMap = false
                          }
                        }
                      },
                      [_vm._v("List")]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "gmap-map",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showMap,
                      expression: "showMap"
                    }
                  ],
                  attrs: {
                    center: _vm.mapCenter,
                    zoom: _vm.zoomLevel,
                    options: _vm.mapStyles,
                    id: "vue-map-container",
                    "aria-label": "Map of digital resource locations"
                  }
                },
                [
                  _vm._l(_vm.filteredDigitalResources, function(
                    digitalResource
                  ) {
                    return _c("gmap-marker", {
                      key: digitalResource.Facility,
                      attrs: {
                        position: digitalResource,
                        icon: _vm.icon,
                        options: _vm.shapeOptions
                      },
                      on: {
                        click: function(e) {
                          return _vm.shapeClick(digitalResource, e)
                        }
                      }
                    })
                  }),
                  _vm._v(" "),
                  _c(
                    "gmap-info-window",
                    {
                      attrs: {
                        opened: _vm.selectedInfoWindowPosition !== null,
                        position: _vm.selectedInfoWindowPosition
                      },
                      on: { closeclick: _vm.infoWindowCloseClick }
                    },
                    [
                      _c("div", { staticClass: "info-window" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "header-column-left" }, [
                            _c("h3", { staticClass: "info-window-header" }, [
                              _vm.selectedItem.Facility
                                ? _c("b", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.selectedItem.Facility
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.openLink(
                                          _vm.selectedItem["Facility Website"]
                                        )
                                      }
                                    }
                                  })
                                : _c("b", [_vm._v("Digital resource location")])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "header-column-right" }, [
                            _vm.selectedItem["Computers available?"] == "Yes" ||
                            _vm.selectedItem["Wi-Fi"] == "Yes" ||
                            _vm.selectedItem["Printing?"] == "Yes" ||
                            _vm.selectedItem["Availability"] == "Yes"
                              ? _c(
                                  "span",
                                  [
                                    _vm.selectedItem["Computers available?"] ==
                                    "Yes"
                                      ? _c("DesktopIcon", {
                                          attrs: { title: "Computer" }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.selectedItem["Wi-Fi"] == "Yes"
                                      ? _c("WifiIcon", {
                                          attrs: { title: "Indoor Wi-Fi" }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.selectedItem["Availability"] == "Yes"
                                      ? _c("WifiIcon", {
                                          staticClass: "wifi-icon-outdoor",
                                          attrs: { title: "Outdoor Wi-Fi" }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.selectedItem["Printing"] == "Yes"
                                      ? _c("PrinterIcon", {
                                          attrs: { title: "Printer" }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.selectedItem["Scanning"] == "Yes"
                                      ? _c("ScannerIcon", {
                                          attrs: { title: "Scanner" }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "column" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.selectedItem["Street Address - Line 1"]
                                )
                              )
                            ]),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.selectedItem["Phone Number"]))
                            ]),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "transit-row" },
                              [
                                _vm.selectedItem["Bus"] == "Yes"
                                  ? _c("BusIcon", { attrs: { title: "Bus" } })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.selectedItem["Metro"] == "Yes"
                                  ? _c("SubwayIcon", {
                                      attrs: { title: "Metro" }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c("br")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "column" }, [
                            _vm.selectedItem["Days of Operation"] &&
                            _vm.selectedItem["Days of Operation"] != "N/A" &&
                            _vm.selectedItem["Hours"] &&
                            _vm.selectedItem["Hours"] != "N/A"
                              ? _c("b", [_vm._v("Hours")])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedItem["Days of Operation"] &&
                            _vm.selectedItem["Days of Operation"] != "N/A" &&
                            _vm.selectedItem["Hours"] &&
                            _vm.selectedItem["Hours"] != "N/A"
                              ? _c(
                                  "ul",
                                  { staticClass: "operations-list" },
                                  _vm._l(
                                    _vm.selectedItem["Days of Operation"],
                                    function(day, index) {
                                      return _c("li", { key: day }, [
                                        _vm._v(
                                          _vm._s(day) +
                                            ": " +
                                            _vm._s(
                                              _vm.selectedItem["Hours"][index]
                                            )
                                        )
                                      ])
                                    }
                                  ),
                                  0
                                )
                              : _vm._e()
                          ])
                        ]),
                        _c("br"),
                        _c("br"),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-window-body" }, [
                          _vm.selectedItem["Specialty Software"] &&
                          _vm.selectedItem["Specialty Software"] != "N/A"
                            ? _c("span", [
                                _c("b", [_vm._v("Specialty Software:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.selectedItem["Specialty Software"]
                                    )
                                ),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedItem["Accessibility"] &&
                          _vm.selectedItem["Accessibility"] != "N/A"
                            ? _c("span", [
                                _c("b", [_vm._v("Accessibility Computers:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.selectedItem["Accessibility"])
                                ),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedItem["Eligibility Requirements"] &&
                          _vm.selectedItem["Eligibility Requirements"] != "N/A"
                            ? _c("span", [
                                _c("b", [_vm._v("Eligibility Requirements:")]),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.selectedItem[
                                        "Eligibility Requirements"
                                      ]
                                    )
                                  }
                                }),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedItem["Printing"] == "Yes"
                            ? _c("span", [
                                _c("b", [_vm._v("Printing Cost Per Page:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.selectedItem["Printing Cost Per Page"]
                                    )
                                ),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedItem["Reservations Needed?"] == "Yes"
                            ? _c("span", [
                                _c("b", [_vm._v("Reservations Needed:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.selectedItem["Reservations Needed?"]
                                    )
                                ),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedItem["Reservations Needed?"] == "Yes" &&
                          _vm.selectedItem["Reservation Requirements"] != "N/A"
                            ? _c("span", [
                                _c("b", [_vm._v("Reservation Requirements:")]),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.selectedItem[
                                        "Reservation Requirements"
                                      ]
                                    )
                                  }
                                }),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedItem["Assistance Languages"] &&
                          _vm.selectedItem["Assistance Languages"] != "N/A"
                            ? _c("span", [
                                _c("b", [_vm._v("Assistance Languages:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.selectedItem["Assistance Languages"]
                                    )
                                ),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedItem["Trainings"] &&
                          _vm.selectedItem["Trainings"] != "N/A"
                            ? _c("span", [
                                _c("b", [_vm._v("Trainings:")]),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.selectedItem["Trainings"]
                                    )
                                  }
                                }),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedItem["Target Populations"] &&
                          _vm.selectedItem["Target Populations"] != "N/A"
                            ? _c("span", [
                                _c("b", [_vm._v("Target Populations:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.selectedItem["Target Populations"]
                                    )
                                ),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedItem["Notes/comments"] &&
                          _vm.selectedItem["Notes/comments"] != "N/A"
                            ? _c("span", [
                                _c("b", [_vm._v("Additional Information:")]),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.selectedItem["Notes/comments"]
                                    )
                                  }
                                }),
                                _c("br")
                              ])
                            : _vm._e()
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.selectedCoordinates && !_vm.selectedCoordinates.fac
                    ? _c("gmap-marker", {
                        attrs: { position: _vm.selectedCoordinates, radius: 24 }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.civicAssocationsSelected
                    ? _c("gmap-polygon", {
                        attrs: {
                          path: _vm.civicAssocationsSelected.paths,
                          options: _vm.locationOptions
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedCoordinates && _vm.radiusSelected
                    ? _c("GmapCircle", {
                        attrs: {
                          center: _vm.selectedCoordinates,
                          radius: _vm.radiusSelected * 1609,
                          visible: true,
                          options: {
                            fillColor: "blue",
                            fillOpacity: 0.1,
                            strokeWeight: 0.7,
                            strokeColor: "blue"
                          }
                        }
                      })
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.showMap,
                      expression: "!showMap"
                    }
                  ],
                  staticClass: "list-pane"
                },
                _vm._l(_vm.filteredDigitalResources, function(digitalResource) {
                  return _c(
                    "div",
                    { key: digitalResource.Facility, staticClass: "project" },
                    [
                      _c("div", [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "list-header-column-left" },
                            [
                              _c("h3", { staticClass: "h3-list" }, [
                                digitalResource.Facility
                                  ? _c("b", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          digitalResource.Facility
                                        )
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.openLink(
                                            digitalResource["Facility Website"]
                                          )
                                        }
                                      }
                                    })
                                  : _c("b", [
                                      _vm._v("Digital resource location")
                                    ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "list-header-column-right" },
                            [
                              digitalResource["Computers available?"] ==
                                "Yes" ||
                              digitalResource["Wi-Fi"] == "Yes" ||
                              digitalResource["Printing?"] == "Yes" ||
                              digitalResource["Availability"] == "Yes"
                                ? _c(
                                    "span",
                                    [
                                      digitalResource["Computers available?"] ==
                                      "Yes"
                                        ? _c("DesktopIcon", {
                                            attrs: { title: "Computer" }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      digitalResource["Wi-Fi"] == "Yes"
                                        ? _c("WifiIcon", {
                                            attrs: { title: "Indoor Wi-Fi" }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      digitalResource["Availability"] == "Yes"
                                        ? _c("WifiIcon", {
                                            staticClass: "wifi-icon-outdoor",
                                            attrs: { title: "Outdoor Wi-Fi" }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      digitalResource["Printing"] == "Yes"
                                        ? _c("PrinterIcon", {
                                            attrs: { title: "Printer" }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      digitalResource["Scanning"] == "Yes"
                                        ? _c("ScannerIcon", {
                                            attrs: { title: "Scanner" }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("br")
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "no-vertical-margin" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(digitalResource["Street Address - Line 1"])
                            )
                          ]),
                          _vm._v(" "),
                          digitalResource["Phone Number"]
                            ? _c("span", [
                                _c("br"),
                                _vm._v(_vm._s(digitalResource["Phone Number"]))
                              ])
                            : _vm._e(),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "transit-row" },
                            [
                              digitalResource["Bus"] == "Yes"
                                ? _c("BusIcon", { attrs: { title: "Bus" } })
                                : _vm._e(),
                              _vm._v(" "),
                              digitalResource["Metro"] == "Yes"
                                ? _c("SubwayIcon", {
                                    attrs: { title: "Metro" }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c("br")
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c("p", [
                          digitalResource["Days of Operation"] &&
                          digitalResource["Days of Operation"] != "N/A" &&
                          digitalResource["Hours"] &&
                          digitalResource["Hours"] != "N/A"
                            ? _c("b", [_vm._v("Hours")])
                            : _vm._e(),
                          _vm._v(" "),
                          digitalResource["Days of Operation"] &&
                          digitalResource["Days of Operation"] != "N/A" &&
                          digitalResource["Hours"] &&
                          digitalResource["Hours"] != "N/A"
                            ? _c(
                                "ul",
                                { staticClass: "operations-list" },
                                _vm._l(
                                  digitalResource["Days of Operation"],
                                  function(day, index) {
                                    return _c("li", { key: day }, [
                                      _vm._v(
                                        _vm._s(day) +
                                          ": " +
                                          _vm._s(
                                            digitalResource["Hours"][index]
                                          )
                                      )
                                    ])
                                  }
                                ),
                                0
                              )
                            : _vm._e()
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c("p", { staticClass: "no-vertical-margin" }, [
                          digitalResource["Specialty Software"] &&
                          digitalResource["Specialty Software"] != "N/A"
                            ? _c("span", [
                                _c("b", [_vm._v("Specialty Software:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      digitalResource["Specialty Software"]
                                    )
                                ),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          digitalResource["Accessibility"] &&
                          digitalResource["Accessibility"] != "N/A"
                            ? _c("span", [
                                _c("b", [_vm._v("Accessibility Computers:")]),
                                _vm._v(
                                  " " + _vm._s(digitalResource["Accessibility"])
                                ),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          digitalResource["Eligibility Requirements"] &&
                          digitalResource["Eligibility Requirements"] != "N/A"
                            ? _c("span", [
                                _c("b", [_vm._v("Eligibility Requirements:")]),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      digitalResource[
                                        "Eligibility Requirements"
                                      ]
                                    )
                                  }
                                }),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          digitalResource["Printing"] == "Yes"
                            ? _c("span", [
                                _c("b", [_vm._v("Printing Cost Per Page:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      digitalResource["Printing Cost Per Page"]
                                    )
                                ),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          digitalResource["Reservations Needed?"] == "Yes"
                            ? _c("span", [
                                _c("b", [_vm._v("Reservations Needed:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      digitalResource["Reservations Needed?"]
                                    )
                                ),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          digitalResource["Reservations Needed?"] == "Yes" &&
                          digitalResource["Reservation Requirements"] != "N/A"
                            ? _c("span", [
                                _c("b", [_vm._v("Reservation Requirements:")]),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      digitalResource[
                                        "Reservation Requirements"
                                      ]
                                    )
                                  }
                                }),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          digitalResource["Assistance Languages"] &&
                          digitalResource["Assistance Languages"] != "N/A"
                            ? _c("span", [
                                _c("b", [_vm._v("Assistance Languages:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      digitalResource["Assistance Languages"]
                                    )
                                ),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          digitalResource["Trainings"] &&
                          digitalResource["Trainings"] != "N/A"
                            ? _c("span", [
                                _c("b", [_vm._v("Trainings:")]),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      digitalResource["Trainings"]
                                    )
                                  }
                                }),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          digitalResource["Target Populations"] &&
                          digitalResource["Target Populations"] != "N/A"
                            ? _c("span", [
                                _c("b", [_vm._v("Target Populations:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      digitalResource["Target Populations"]
                                    )
                                ),
                                _c("br")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          digitalResource["Notes/comments"] &&
                          digitalResource["Notes/comments"] != "N/A"
                            ? _c("span", [
                                _c("b", [_vm._v("Additional Information:")]),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      digitalResource["Notes/comments"]
                                    )
                                  }
                                }),
                                _c("br")
                              ])
                            : _vm._e()
                        ])
                      ])
                    ]
                  )
                }),
                0
              )
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-15b5a7ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15b5a7ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/digitalResources/digitalResources.vue
// module id = F+2R
// module chunks = 1